// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1Fbb-","title":"Header_title__1U2Dw","side":"Header_side__sH_SR"};